import { computed, type ComputedRef, ref } from 'vue'
import { type MaybeElementRef, useIntersectionObserver } from '@vueuse/core'

export interface StickyGridFiltersBar {
    gridTopBarWrapperElement: MaybeElementRef
    gridElement: MaybeElementRef
    classGridTopBarWrapper: ComputedRef<Record<string, boolean>>
    gridTopBarHeight: '48px'
}

export function useStickyGridFiltersBar(): StickyGridFiltersBar {
    const gridTopBarWrapperElement: MaybeElementRef = ref(null)
    const gridElement: MaybeElementRef = ref(null)
    const isGridTopBarStuck = ref(false)
    const gridTopBarHeight = '48px' as const

    useIntersectionObserver(
        gridTopBarWrapperElement,
        ([entry]) => {
            if (!entry) {
                return
            }

            isGridTopBarStuck.value = entry.isIntersecting
        },
        {
            root: gridElement,
            rootMargin: `-${gridTopBarHeight} 0px 0px 0px`,
            threshold: 0.1,
        }
    )

    const classGridTopBarWrapper = computed(() => ({
        'stuck': isGridTopBarStuck.value,
    }))

    return {
        gridTopBarWrapperElement,
        gridElement,
        classGridTopBarWrapper,
        gridTopBarHeight,
    }
}
